import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import GoogleMapReact from 'google-map-react'
import moment from 'moment'

import { fetchAffiliate, jumpToBookingFlow } from '../actions/acAffiliatePage'
import { addressSuggestionSelected } from '../actions/acBookingFlow'

import LangSelector from './LangSelector'
import UserDropdown from './UserDropdown'
import { GeosuggestInput } from "./InputsFunctions"
import { PootsyTitle, PootsyButton, UserNavLayout, MapMarker, ExternalPrimaryLink, JsonLd } from './DesignFunctions'
import Footer from './Footer'

import defaultCoverBg from '../static/img/agency-bg.png'
import appPicto from '../static/img/use-pootsy-picto.png'
import ZipCodeNotCoveredModal from "./bookingflow/ZipCodeNotCoveredModal";

const defaultMapCenter = { lat: 50.845, lng: 4.354 } // < defaults to centering on brussels
class AffiliatePage extends Component {
	state = {
		coverImg: "",
		displayLogo: true
	}
	componentWillMount = () => {
		this.fetchAffiliate()
	}
	componentDidMount = () => {
		setTimeout(() => { window.scrollTo(0, 0) }, 100)
	}
	componentWillReceiveProps = newProps => {
		let { t } = this.context
		let { lang, affiliate } = this.props
		if(newProps.lang !== lang){
			this.fetchAffiliate()
		}
		if(!affiliate.id && newProps.affiliate.id){
			document.title = newProps.affiliate.name
			let metaTag = document.querySelector('meta[name="description"]')
			metaTag.setAttribute(
				"content", t('affiliate_meta_description', { affiliateName: newProps.affiliate.name })
			)
			this.setState({ coverImg: newProps.affiliate.cover })
		}
	}
	fetchAffiliate = () => {
		let { match: { params } } = this.props
		this.props.dispatch(fetchAffiliate(params.slug))
	}
	handleAddressClick = suggestion => {
		this.props.dispatch(addressSuggestionSelected(suggestion))
	}
	handleBookingRequest = () => {
		this.props.dispatch(jumpToBookingFlow(this.props.affiliate.id))
	}
	handleCoverImgError = e => {
		this.setState({ coverImg: defaultCoverBg })
	}
	handleLogoError = e => {
		this.setState({ displayLogo: false })
	}
	render(){
		let { t } = this.context
		let { affiliate } = this.props
		let { coverImg, displayLogo } = this.state
		let jsonLdDataAffiliateRating;
		if (affiliate.id){ jsonLdDataAffiliateRating = {
				"@context": "http://schema.org",
				"@type": "Organization",
				"name": affiliate.name,
				"telephone": affiliate.phone,
				"aggregateRating": {
					"@type": "AggregateRating",
					"ratingValue": "82",
					"bestRating": "100",
					"worstRating": "1",
					"ratingCount": "13"
				},
				"review": {
					"@type": "Review",
					"reviewRating": {
						"@type": "Rating",
						"worstRating": 1,
						"bestRating": 5,
						"ratingValue": 4.2
					},
					"author": {
						"@type": "Person",
						"name": "Amaury Gerard"
					},
					"publisher": {
						"@type": "Organization",
						"name": "Pootsy"
					},
					"datePublished": "2018-03-17T20:00",
				}
			}
		}
		return(
			<div className="AffiliatePage">
				<JsonLd data={jsonLdDataAffiliateRating}/>
				{this.props.bookingFlow.enterZipCodeNotCovered && <ZipCodeNotCoveredModal />}
				<UserNavLayout customClass="affiliate-page-nav">
					<div className="affiliate-name">
						{affiliate.name}
					</div>
					<div className="right">
						<LangSelector/>
						<UserDropdown/>
					</div>
				</UserNavLayout>
				<div className="cover-background">
					<img alt="bg-cover" className="background-cover" src={coverImg} onError={this.handleCoverImgError}/>
					<div className="gradient"/>
				</div>
				<div className="content">
					<section className="logo-slogan">
						{displayLogo ? (
							<img alt="logo" className="logo" src={affiliate.logo} onError={this.handleLogoError}/>
						) : (
							<div className="logo-fallback" itemProp="name">{affiliate.name}</div>
						)}
						<div className="header">{affiliate.slogan}</div>
					</section>
					<section className="bio-book">
						<div className="left">
							{affiliate.bio}
							<div className="details">
								<div key={t('phone')} className="detail">
									<div className="label">{t('phone')}</div>
									<div className="value">{affiliate.phone}</div>
								</div>
								<div key={t('email')} className="detail">
									<div className="label">{t('email')}</div>
									<div className="value"><a className="item" href={"mailto:"+affiliate.email}>{affiliate.email}</a></div>
								</div>
								<div key={t('rating')} className="detail">
									<div className="label">{t('rating')}</div>
									<div className="value">
										<span>
											 <span>
												{t('rated', { note: 4.2, total: 5, total_formatted: 5 })}
											 </span>
										</span>
									</div>
								</div>
							</div>
						</div>
						<div className="right">
							<PootsyTitle title={t("booking_flow_first_step_header")}/>
							<div className="subtitle">{t('booking_flow_first_step_input_prompt')}</div>
							<GeosuggestInput
								geoSuggestProps={{
									placeholder: t('address_input_placeholder'),
									country: "be",
									onSuggestSelect: this.handleAddressClick
								}}
							/>
							<PootsyButton text={t('book_your_service_button')} onClick={this.handleBookingRequest}/>
						</div>
					</section>
					<section className="opening-hours-section">
						<div className="black-bg"/>
						{affiliate.openingHours && ["1", "2", "3", "4", "5", "6", "7"].map(weekDay => {
							let dayOpeningHours = affiliate.openingHours.filter(oh => oh.day === weekDay)
							return (
								<div key={weekDay} className="weekday-hours">
									<div className="day">{moment(weekDay, "E").format('dddd')}</div>
									<div className="opening-hours">
									{dayOpeningHours.length === 0 && <div className="closed">{t('closed')}</div>}
									{dayOpeningHours.map(oh =>
										<div key={oh.start.format() + oh.end.format()} className="opening-hour">
											{`${oh.start.format('HH:mm')} - ${oh.end.format('HH:mm')}`}
										</div>
									)}
									</div>
								</div>
							)
						})}
					</section>
					{affiliate.address && affiliate.address.lat &&
						<section className="map">
							<div className="map-container">
								<GoogleMapReact
									zoom={13}
									defaultCenter={defaultMapCenter} // ( defined at top of file, otherwise there is a warning at each render because of redefining the variable )
									center={{ lat: affiliate.address.lat, lng: affiliate.address.lng }}
									bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_API_KEY }}
								>
									<MapMarker lat={affiliate.address.lat} lng={affiliate.address.lng}/>
								</GoogleMapReact>
							</div>
							<div className="map-overlay">
								<PootsyTitle title={t('address')}/>
								<div className="address-inline">{affiliate.address.inline}</div>
								<a target="_blank" rel="noreferrer noopener" href={`https://www.google.com/maps/dir/current+location/${affiliate.address.lat},${affiliate.address.lng}`}>
									<PootsyButton text={t('itinerary')}/>
								</a>
							</div>
						</section>
					}
					<section className="pootsy-app">
						<div className="left">
							<PootsyTitle title={t("manage_your_booking_with_the_app")}/>
							<div className="pootsy-app-prompt">{t("manage_your_booking_with_the_app_desc")}</div>
							<ExternalPrimaryLink to="/" label={t("discover_pootsy")}/>
						</div>
						<img alt="phone" className="use-pootsy-pic" src={appPicto}/>
					</section>
				</div>
				<Footer/>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	affiliate: state.dataReducer.affiliatePublicData,
	bookingFlow: state.metadataReducer.bookingFlow,
	lang: state.i18nState.lang
})
AffiliatePage.contextTypes = { t: PropTypes.func }
export default connect(mapStateToProps)(AffiliatePage);



// WEBPACK FOOTER //
// ./src/components/AffiliatePage.js